import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, BusinessType, CartSession, GeneralConfigType, ItemsDisplayType, KeyValueInt, KeyValues10, KeyValues30, KeyValues20, KeyValues3, KeyValues5, KeyValueSet, LocalService, Paging, PricingManagementInitialization, PricingManagementWrapper, ProductInitialization, ProductLogDetailsInitialization, ProductLogStatus, ProductPrice, ProductWrapper, SerialNumberGenerate, SerialNumberInitialization, Status, StatusWithId, UsageLimitType, Wrappers10, Wrappers15, ProductEntryType, KeyValueId, Wrappers20 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class ProductManagementService {
  private controllerName = service_controllers_methods.product.controller;
  private methods = service_controllers_methods.product.methods;
  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public ensureUsageLimits() {
    this.getUsageLimitConfigs([]).subscribe(result => {
      this.localService.usageLimits = result;
    });
  }

  public saveProduct(wrapper: ProductWrapper, ctryCode = ''): any {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      wrapper: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveProduct, body);
  }

  public getProductInitialization(strId: string, strBusinessId: string, ctryCode = ''): Observable<ProductInitialization> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      strId: strId,
      strBusiness: strBusinessId,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductInitialization, body);
  }

  public getProducts(businessId: string, isOnlyLessStock: boolean, selectedProductCategory: string, paging: Paging, ctryCode = '', productEntryType: ProductEntryType = ProductEntryType.Billing, isLoadBasePricingDetails?: boolean, businessType: BusinessType = BusinessType.EndCustomer): Observable<Wrappers20> {
    // if (paging == null)
    //   paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingProducts);

    let body = {
      sel: this.localService.getSelected(ctryCode),
      businessId: businessId,
      pag: paging,
      productEntryType: productEntryType,
      isOnlyLessStock: isOnlyLessStock ? '1' : '0',
      isLoadBasePricingDetails: isLoadBasePricingDetails ? '1' : '0',
      selectedProductCategory: selectedProductCategory,
      businessType: businessType
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProducts, body, true, false, true);
  }

  public getProduct(strId: string, ctryCode = ''): Observable<ProductWrapper> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProduct, body);
  }

  public getSearchedProduct(strBusinessId: string, strSearchKey: string, isBarCode = false, ctryCode = ''): Observable<KeyValues30[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: strSearchKey, v1: strBusinessId, v2: isBarCode ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSearchedProduct, body, false);
  }

  public getAllProductsToDisplay(strBusinessId: string, strBillingId: string, strExpectedBusinessType: string, ctryCode: string, isExcluded: boolean, isShowSpinner = false): Observable<KeyValues30[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { isSelected: isExcluded, v1: strBusinessId, v2: strBillingId, v3: strExpectedBusinessType } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAllProductsToDisplay, body, isShowSpinner);
  }

  public addStock(data: KeyValueSet, ctryCode = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      wrapper: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.AddStock, body);
  }

  public getPrice(strProductId: string, strBusinessType: string, hasValidBatchDetails: boolean, isExcluded: boolean, businessId: string, ctryCode?: string, measurementType?: number, isTaxDetailsRequired?: boolean): Observable<ProductPrice[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { isSelected: isExcluded, v1: strProductId, v2: strBusinessType, v3: hasValidBatchDetails ? '1' : '0', v4: measurementType ? measurementType.toString() : undefined, v5: businessId, v6: isTaxDetailsRequired ? '1' : '0' } as KeyValues10
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPrice, body);
  }

  public saveSerialNumber(data: KeyValues5, ctryCode = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveSerialNumber, body);
  }

  public getSerialNumbersInitialization(strProductId: string, purchaseEntryDetailId: string, ctryCode = ''): Observable<SerialNumberInitialization> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { v1: strProductId, v2: purchaseEntryDetailId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSerialNumbersInitialization, body);
  }

  public getSerialNumber(strId: string, ctryCode = ''): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSerialNumber, body);
  }

  public getSerialNumbers(strProductId: string, purchaseEntryDetailId: string, paging: Paging, ctryCode = ''): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { v1: strProductId, v2: purchaseEntryDetailId } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSerialNumbers, body);
  }

  public getAvailableSerialNumbers(strProductId: string, ctryCode = ''): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: strProductId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAvailableSerialNumbers, body);
  }

  public downloadProducts(businessId: string, ctryCode = '') {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: businessId } as KeyValues3
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.DownloadProducts, body, true, true);
  }

  public getStockReport(strBusinessId: string, isAllProducts: boolean, isIncludePrice: boolean, paging: Paging) {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: isAllProducts ? '1' : '0', v3: isIncludePrice ? '1' : '0' } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.GetStockReport, body, true, true);
  }

  public getMonthlyStockReport(strBusinessId: string) {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.GetMonthlyStockReport, body, true, true);
  }

  public getProductLogs(businessId: string, ctryCode = ''): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductLogs, body);
  }

  public getProductLogDetailsInitialization(logId: string, ctryCode = ''): Observable<ProductLogDetailsInitialization> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: logId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductLogDetailsInitialization, body);
  }

  public getProductLogDetails(logId: string, iRow: number, productLogStatus: ProductLogStatus, ctryCode = ''): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: logId, v1: iRow.toString(), v2: productLogStatus.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductLogDetails, body);
  }

  public getPricingManagment(strBizId: string, strProductId: string, batchId?: string, measurementType?: number, isLoadAll = false, ctryCode = ''): Observable<PricingManagementInitialization> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { key: strProductId, v1: strBizId, v2: batchId, v3: isLoadAll ? '1' : '0', v4: measurementType ? measurementType.toString() : undefined } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPricingManagment, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public getUsageLimits(strBizId: string, usageLimitType: UsageLimitType): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBizId, v2: usageLimitType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUsageLimits, body);
  }

  public getUsageLimitConfigs(usageLimitTypes: UsageLimitType[]): Observable<KeyValueInt[]> {
    let body = {
      ids: usageLimitTypes
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUsageLimitConfigs, body);
  }

  public generateSerialNumbers(data: SerialNumberGenerate): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GenerateSerialNumbers, body, true, false, true);
  }

  public isValidSerialNumber(productId: string, serialNumber: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: productId, v2: serialNumber } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.IsValidSerialNumber, body);
  }

  public getItemsToDisplay(paging: Paging, itemsDisplayType: ItemsDisplayType = ItemsDisplayType.ProductsForOneBusiness, isOnlyActive: boolean = true, businessType: BusinessType = BusinessType.EndCustomer, businessId?: string, ctryCode = ''): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(undefined, ctryCode),
      dt: { isSelected: isOnlyActive, v1: businessId, v2: businessType.toString(), v3: itemsDisplayType.toString() } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetItemsToDisplay, body);
  }

  public getCartSession(businessId: string, countryCode: string): Observable<CartSession> {
    let body = {
      sel: this.localService.getSelected(undefined, countryCode),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCartSession, body);
  }

  public SaveCartSession(businessId: string, productId: string, quantity: string | number | null): Observable<CartSession> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: productId, v3: quantity } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCartSession, body, false);
  }

  public getBatchTitleWithInventory(productId: string, isOnlyActive: boolean = true): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: productId, v2: isOnlyActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBatchTitleWithInventory, body);
  }

  public savePrice(pricings: PricingManagementWrapper[], pricingsExclude: PricingManagementWrapper[], productId: string, batchId?: string, measurementType?: number): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: productId, v2: batchId, v3: measurementType ? measurementType.toString() : undefined } as KeyValues3,
      dt1: pricings,
      dt2: pricingsExclude
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePrice, body);
  }

  public deletePrice(productId: string, batchId?: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: productId, v2: batchId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeletePrice, body);
  }

  public saveCustomField(data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCustomField, body);
  }

  public getCustomFields(businessId: string, isActive: boolean): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCustomFields, body);
  }

  public saveChildMeasurementForProduct(data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveChildMeasurementForProduct, body);
  }

  public getChildMeasurementForProduct(productId: string, measurementType: number, parentMeasurementType: number): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: productId, v2: measurementType.toString(), v3: parentMeasurementType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetChildMeasurementForProduct, body);
  }

  public getChildMeasurementsForProduct(productId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: productId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetChildMeasurementsForProduct, body);
  }

  public getProductIdOfBarCode(businessId: string, value: string, ctryCode: string = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { v1: value, v2: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductIdOfBarCode, body, false);
  }

  public updateBaseAmount(data: KeyValueId[], businessType: BusinessType, ctryCode: string = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { v1: businessType.toString() } as KeyValues3,
      data: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBaseAmount, body, true, false, true);
  }

  public saveProductRawInventoryConfig(data: KeyValues10, ctryCode: string = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveProductRawInventoryConfig, body);
  }

  public getProductRawInventoryConfigs(productId: string, ctryCode: string = ''): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(ctryCode),
      dt: { v1: productId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetProductRawInventoryConfigs, body);
  }

  public getStockCount(businessId: string): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetStockCount, body, true, false, true);
  }
}
